var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/tag.ts
import { acss } from "@adornis/chemistry/directives/acss.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { TAG_KEY, TAG_SCHEMA } from "../../schema/nodes/tag.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { isNodeSelection } from "../util.js";
var tag = () => ({
  node: {
    name: TAG_KEY,
    schema: TAG_SCHEMA()
  },
  menuItems: [
    {
      label: "Tag",
      icon: "tag",
      run: (view) => runInsertNode(TAG_KEY)(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ]
});
var NodeTag = class extends BuildifyLitElement {
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    const slot = this.renderRoot.querySelector("slot");
    if (!slot)
      return;
    const assignedElements = slot.assignedElements();
    if (!assignedElements.length)
      this.append(document.createElement("div").innerText = "#Tag");
  }
  content({ content, mode }) {
    return html`
      <span
        tag
        ${css({
      borderRadius: "8px",
      backgroundColor: "#CECECE",
      padding: "8px",
      width: "max-content",
      display: "block"
    })}
      >
        <slot ${acss({ "&::slotted(*)": { marginBlock: "0 !important" } })}></slot>
      </span>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          display: "inline-block",
          verticalAlign: "middle"
        }
      }
    ];
  }
};
NodeTag = __decorateClass([
  customElement("node-tag")
], NodeTag);
export {
  NodeTag,
  tag
};
